export default __webpack_public_path__ + "static/media/icon-sidebar-upgrade.43e907d7.svg";